import { render, staticRenderFns, recyclableRender, components } from "./rate.vue?vue&type=template&id=16f66286&scoped=true&"
var renderjs
import script from "./rate.vue?vue&type=script&lang=js&"
export * from "./rate.vue?vue&type=script&lang=js&"
import style0 from "./rate.vue?vue&type=style&index=0&id=16f66286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f66286",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/mine/my-course/rate.vue"
export default component.exports